import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import { changeUserBusinessUnits } from '@containers/Admin/containers/UserPage/actions';
import { BusinessUnitMultiSelect } from '@containers/Admin/shared/BusinessUnitMultiSelect';

interface SelectBusinessUnitsProps {
  canEditBusinessUnits: boolean;
}

export const SelectBusinessUnits = ({ canEditBusinessUnits }: SelectBusinessUnitsProps) => {
  const dispatch = useDispatch();
  const {
    allBusinessUnits,
    userData: { id, businessUnits = [], businessUnitsInfo = [] },
  } = useSelector((state: RootStateOrAny) => state.get('userPage').toJS()); // FIXME replace to typing store

  const displayBusinessUnits = canEditBusinessUnits
    ? allBusinessUnits
    : businessUnitsInfo;

  return (
    <BusinessUnitMultiSelect
      canEditBusinessUnits={canEditBusinessUnits}
      allBusinessUnits={displayBusinessUnits}
      selectedBusinessUnits={businessUnits}
      onChangeBusinessUnits={(nextSelectedBusinessUnits) => {
        dispatch(changeUserBusinessUnits(nextSelectedBusinessUnits, id));
      }}
    />
  );
};